<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/upload_img2222"
            name="img"
            :show-file-list="false"
            :before-upload="handleUpload"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl+'?imageView2/0/w/50'" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="链接" prop="url">
        <el-input v-model="formData.url"></el-input>
      </el-form-item>
      <el-form-item label="是否显示" prop="is_show">
        <el-select v-model="formData.is_show" placeholder="请选择显示选项" filterable>
          <el-option v-for="item in showList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
export default {
  name: 'slideshow_add',
  props: [
    'visible', 'id', 'showList'
  ],
  data () {
    return {
      title: '添加轮播',
      uploadPrepareResp: {},
      formData: {
        title: '',
        pic: '',
        url: '',
        is_show: 20
      },
      picUrl: '',
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.picUrl = ''
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑轮播'
        this.getInfo(this.id)
      } else {
        this.title = '添加轮播'
      }
      this.uplodPrepare()
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/slideshow/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          pic: res.data.pic,
          url: res.data.url,
          is_show: res.data.is_show
        }
        this.picUrl = res.data.pic_url
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'image/' + this.getDateString() + '/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.pic = res.key
        this.picUrl = this.uploadPrepareResp.res_domain + res.key
      }
      observable.subscribe({ next, error, complete })
      this.uplodPrepare()
      return false
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    getDateString () {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
